export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'BE',
  'merchantReturnLink': 'https://www.timberland.be/nl-be/klantenservice/retour-instructies ',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
